import React from 'react';
import './FooterSection.css'; // Your CSS file
import internLogo from '../assets/img/intern_logo.png'; // Path to Intern logo image
import logo from '../assets/img/midc_logo_w.png'; // Adjust the path to your logo

// Import Bootstrap icons
import 'bootstrap-icons/font/bootstrap-icons.css';

const FooterSection = () => {
  const currentYear = new Date().getFullYear(); // Dynamic year

  return (
    <footer className="footer-section container-fluid text-white">
      <div className="container">
        <div className="row justify-content-center text-center">

          {/* Logo in Center */}
          <div className="logo">
            <img src={logo} alt="Medical Infrared Diagnostic Center" className="img-fluid" />
          </div>

          {/* Description */}
          <div className="col-12  text-black">
            <p className="text-black">
              Reliable and Accurate, Precise and Objective, Considerable Financial Savings Over Conventional Investigations.
            </p>
          </div>

          {/* Social Media Icons */}
          {/* <div className="social-icons text-black">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="mx-3">
              <i className="bi bi-twitter"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-linkedin"></i>
            </a>
          </div> */}

          {/* Footer Bottom */}
          <div className="footer-bottom col-12 m-2 d-flex justify-content-between align-items-center flex-wrap">
            {/* Copyright */}
            <p className="mb-3 text-black">© MIDC {currentYear}. All rights reserved.</p>

            {/* Developer Info */}
            <p className="mb-3 text-black d-flex align-items-center comp">
              Design & Developed by{' '}
              <a
                href="https://internchoice.com"
                target="_blank"
                rel="noopener noreferrer"
                className="intern-choice-link d-flex align-items-center"
              >
                <img src={internLogo} alt="Intern Choice Logo" className="intern-logo" />
                <span className="intern-choice">Intern Choice</span>
              </a>
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default FooterSection;




// import React from 'react';
// import './FooterSection.css'; // Your CSS file
// import internLogo from '../assets/img/intern_logo.png'; // Path to Intern logo image
// import logo from '../assets/img/midc_logo_w.png'; // Adjust the path to your logo

// // Import Bootstrap icons (You can use the CDN or install them via npm)
// import 'bootstrap-icons/font/bootstrap-icons.css';

// const FooterSection = () => {
//   return (
//     <footer className="footer-section container-fluid text-white">
//       <div className="container">
//         <div className="row justify-content-between text-center">
          
//           {/* First Column: Logo and Content */}
//           <div className="col-lg-4 col-md-6 mb-4 text-center">
//             <div className="logo">
//               <img src={logo} alt="Medical Infrared Diagnostic Center" className="img-fluid" />
//             </div>
//             <p className="footer-description">
//               Reliable and Accurate, Precise and Objective, Considerable Financial Savings Over Conventional Investigations.
//             </p>
//           </div>

//           {/* Second Column: Get in Touch */}
//           <div className="col-lg-4 col-md-6 mb-4">
//             <h5 className="footer-heading">Get in Touch</h5>
//             <p className="footer-contact">
//               <a href="mailto:info@midc.com" className="footer-email">
//                 info@midc.com
//               </a>
//             </p>
//           </div>

//           {/* Third Column: Quick Links */}
//           <div className="col-lg-4 col-md-6 mb-4">
//             <h5 className="footer-heading">Quick Links</h5>
//             <ul className="footer-links">
//               <li><a href="/about" className="footer-link">About Us</a></li>
//               <li><a href="/services" className="footer-link">Services</a></li>
//               <li><a href="/contact" className="footer-link">Contact</a></li>
//               <li><a href="/privacy-policy" className="footer-link">Privacy Policy</a></li>
//             </ul>
//           </div>

//         </div>

//         {/* Footer Bottom */}
//         <div className="footer-bottom col-12 m-2 d-flex justify-content-between align-items-center flex-wrap">
//           <p className="mb-3 text-black">© MIDC 2025. All rights reserved.</p>
//           <p className="mb-3 text-black d-flex align-items-center">
//             Design & Developed by {' '}
//             <a href="https://internchoice.com" target="_blank" rel="noopener noreferrer" className="intern-choice-link d-flex align-items-center">
//               <img src={internLogo} alt="Intern Choice Logo" className="intern-logo" />
//               <span className="intern-choice">Intern Choice</span>
//             </a>
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default FooterSection;
